import React from "react";
import { withRouter } from "react-router-dom";
import { withApollo } from "react-apollo";
import Delete from "../../../static/images/svg/Delete.svg";
import ReactModal from "../../Common/ReactModal";
import { ADD_SUPER_ADMIN } from "../../../services/graphql/queries/superAdmin";
import { getUserListQuery } from "../../../services/graphql/queries/user";
import SelectComponent from "../../Common/form-component/SelectComponent";
import DisplayErrors from "../../Common/DisplayErrors";
import SimpleReactValidator from "simple-react-validator";
import Select from "react-select";
import {
  SET_TIMEOUT_VALUE,
  dateInputFormat,
} from "../../../constants/app-constants";
import { errorMessage } from "../../../miscellaneous/error-messages";
class SuperAdminAdd extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      userOptions: [],
      superAdminDetail: { user: null, portalType: "" },
      error: "",
      errors: [],
      modalMessage: "Super Admin added successfully",
      reactModalVisible: false,
      portalTypeOptions: [
        {
          Id: 4,
          name: "Info Portal(BD) ",
        },
      ],
      user: "",
    };
    this.validator = new SimpleReactValidator({
      autoForceUpdate: this,
      element: (message) => <div style={{ color: "red" }}>{message}</div>,
    });
  }
  handleInput = (e) => {
    let value = e.target.value;
    let name = e.target.name;
    this.setState((prevState) => {
      return {
        superAdminDetail: {
          ...prevState.superAdminDetail,
          [name]: parseInt(value),
        },
      };
    });
  };
  getAllUserList() {
    // this.setState({ loading: true, isSearched: true });
    this.props.client
      .query({
        query: getUserListQuery,
        variables: {
          status: 1,
        },
        fetchPolicy: "network-only",
      })
      .then((result) => {
        var allusers = result.data.getListOfOrgUsers;
        let OptionArr = [];
        allusers.forEach((element) => {
          let userType = "";
          if (element.lockedDetail.entityType == 1)
            userType = " - External User";
          OptionArr.push({
            value: element.Id,
            label: element.name + " - " + element.Id + userType,
          });
        });

        this.setState({ userOptions: OptionArr, loading: false, error: "" });
      })
      .catch((error) => {
        this.setState({ loading: false, error: error.message });
      });
  }
  submitData = () => {
    debugger;
    this.props.client
      .mutate({
        mutation: ADD_SUPER_ADMIN,
        variables: {
          portalType: parseInt(this.state.superAdminDetail.portalType),
          userId: parseInt(this.state.user.value),
        },
        fetchPolicy: "no-cache",
      })
      .then((result) => {
        this.props.history.push("/super-admin-list");
      })
      .catch((error) => {
        console.log("~~~error: ", error);
        this.setState({ loading: false, errors: [errorMessage(error)] });
        this.timer = setTimeout(() => {
          this.setState({ errors: [] });
        }, SET_TIMEOUT_VALUE);
      });
  };
  clear = () => {
    this.setState({
      user: "",
      superAdminDetail: {
        portalType: "",
      },
      errors: [],
    });
    this.validator.hideMessages();
  };

  componentDidMount() {
    this.getAllUserList();
  }
  render() {
    const {
      reactModalVisible,
      modalMessage,
      errors,
      superAdminDetail,
      portalTypeOptions,
      userOptions,
      user,
    } = this.state;
    return (
      <>
        <ReactModal
          reactModalVisible={reactModalVisible}
          submitModal={this.submitModal}
          modalMessage={modalMessage}
          requireCancel={false}
        />
        <h1 className="heading m-b-25">Super Admin Add</h1>
        <div
          className="row"
          style={{
            display: errors.length === 0 ? "none" : "block",
          }}
        >
          <div className="col-md-6">
            <div className="alert alert-success" role="alert">
              <div className="row">
                <span className="danger-link">
                  <DisplayErrors errors={errors} />
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            {/* Form Section start */}
            <div className="box-card">
              <div className="row">
                <div className="col-md-6 col-lg-4">
                  <div className="form-group">
                    <label>
                      Employee<span style={{ color: "red" }}>*</span>
                    </label>
                    <Select
                      value={user}
                      onChange={(e) => {
                        this.setState({ user: e });
                      }}
                      options={userOptions}
                      closeMenuOnSelect={true}
                    />
                    {this.validator.message("employee", user, "required")}
                  </div>
                </div>
                <div className="col-md-6 col-lg-4">
                  <SelectComponent
                    required
                    label={"Portal"}
                    title={"portalType"}
                    name={"portalType"}
                    options={portalTypeOptions}
                    optionKey={"name"}
                    valueKey={"Id"}
                    value={superAdminDetail.portalType}
                    placeholder={"Select Portal"}
                    handleChange={this.handleInput}
                    validator={this.validator}
                    validation="required"
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-md-12 col-lg-5">
                  <button
                    type="submit"
                    className="btn btn-danger"
                    onClick={() => {
                      if (this.validator.allValid()) {
                        this.submitData();
                      } else {
                        this.validator.showMessages();
                      }
                    }}
                  >
                    Submit
                  </button>
                  <button
                    type="button"
                    className="btn btn-light m-l-50"
                    onClick={() => this.clear()}
                  >
                    Clear
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(withApollo(SuperAdminAdd));
